import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  Paper,
  Collapse,
  ButtonBase,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { API_AddUser, API_GetUser, API_changepassword } from "./utils/http";
import { AddUser } from "./components/AddUser";
import ListUser from "./components/ListUser";
import { TOKEN_NAME, TOKEN_USERNAME_APP } from "./utils/constDispatch";
import { checkAdminRole, idToTimeDMMMYYYY, showRole } from "./utils/tool";
import AppBarUser from "./components/AppBarBtn";
import { AdminRate } from "./components/AdminRate";

const sxTextField = {
  m: 0.5,
  width: "100%",
  maxWidth: 400,
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: 13,
  },
  "& .MuiInputLabel-root": {
    fontSize: 13,
  },
  "& .MuiFormHelperText-root": {
    fontSize: 12,
  },
};

export default function User() {
  const navigate = useNavigate();
  const my_username = sessionStorage.getItem(TOKEN_USERNAME_APP);
  const [password, set_password] = useState("");
  const [new_password, set_new_password] = useState("");
  const [new_password_confirmation, set_new_password_confirmation] =
    useState("");

  const [user_arr, set_uer_arr] = useState(null);
  // Admin Mail + Rate rarely change, so keep the block collapsed by default.
  const [show_admin_rate, set_show_admin_rate] = useState(false);
  const [open_add_user, set_open_add_user] = useState(false);
  const [change_pw_error, set_change_pw_error] = useState("");

  // Mirrors changePasswordSchema on the backend, so a too-short password is
  // caught here instead of coming back as a 400.
  const MIN_PASSWORD = 8;
  const too_short =
    new_password !== "" && new_password.length < MIN_PASSWORD;
  const mismatch =
    new_password_confirmation !== "" &&
    new_password !== new_password_confirmation;

  const canConfirm =
    password !== "" &&
    new_password.length >= MIN_PASSWORD &&
    new_password !== password &&
    new_password === new_password_confirmation;

  async function GetUser() {
    API_GetUser((data) => {
      if (data.success) {
        let a = [];

        data.data.map((item) => {
          item.role = showRole(item.role);
          item.date = idToTimeDMMMYYYY(item._id);
          a.push(item);
        });

        set_uer_arr(a);
      }
    });
  }

  // AddUser shows the generated password on success, so it needs to know the
  // outcome rather than just being told to close.
  const ClickAddUser = (body, done) => {
    API_AddUser(body, (data) => {
      if (data?.success) {
        GetUser();
        done(true);
      } else {
        done(false, data?.message || "Tạo user thất bại");
      }
    });
  };

  // GET /user là endpoint admin-only, nhưng màn này mở cho mọi role vì panel đổi
  // mật khẩu ai cũng dùng. Không guard thì editer vừa vào đã ăn 403 vô nghĩa.
  useEffect(() => {
    if (checkAdminRole()) {
      GetUser();
    }
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <AppBarUser
        title="Profile"
        onLogout={() => {
          sessionStorage.removeItem(TOKEN_NAME);
          navigate("/login", { replace: true });
        }}
      />

      <Box sx={{ padding: "20px", display: "flex", flexDirection: "column", gap: 2.5 }}>
        {checkAdminRole() ? (
          <>
            <Paper
              elevation={0}
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: "10px",
                p: 2.5,
              }}
            >
              {/* ButtonBase, not Box: keeps the toggle focusable and operable
                  with Enter/Space. */}
              <ButtonBase
                onClick={() => set_show_admin_rate(!show_admin_rate)}
                aria-expanded={show_admin_rate}
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                  borderRadius: "6px",
                  py: 0.5,
                }}
              >
                <Typography
                  sx={{ fontWeight: 600, fontSize: 16, color: "#333" }}
                >
                  Admin Mail &amp; Rate
                </Typography>
                <ExpandMoreIcon
                  sx={{
                    color: "#888",
                    transition: "transform 150ms",
                    transform: show_admin_rate
                      ? "rotate(0deg)"
                      : "rotate(-90deg)",
                  }}
                />
              </ButtonBase>

              {/* Collapse keeps AdminRate mounted, so half-typed rate values
                  survive collapsing. */}
              <Collapse in={show_admin_rate} timeout="auto">
                <Divider sx={{ my: 1.5 }} />
                <AdminRate />
              </Collapse>
            </Paper>

            <Paper
              elevation={0}
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: "10px",
                p: 2.5,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  mb: 1.5,
                }}
              >
                <Typography
                  sx={{ fontWeight: 600, fontSize: 16, color: "#333" }}
                >
                  List User
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  disableElevation
                  startIcon={<AddIcon />}
                  sx={{
                    borderRadius: "20px",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: 13,
                    px: 2,
                  }}
                  onClick={() => set_open_add_user(true)}
                >
                  Add User
                </Button>
              </Box>
              {user_arr != null && (
                <ListUser user_arr={user_arr} get_user={() => GetUser()} />
              )}
            </Paper>

            <AddUser
              open={open_add_user}
              onClose={() => set_open_add_user(false)}
              clickAdd={(body, done) => ClickAddUser(body, done)}
            />
          </>
        ) : null}

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #E0E0E0",
            borderRadius: "10px",
            p: 2.5,
          }}
        >
          <Typography
            sx={{ fontWeight: 600, fontSize: 16, color: "#333", mb: 1.5 }}
          >
            Change Password
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {/* The backend rejects changing anyone else's password (403), so
                there is nothing to pick — take the username from the token. */}
            <Typography sx={{ fontSize: 13, color: "#666", m: 0.5, mb: 1 }}>
              Đang đổi password cho: <b>{my_username}</b>
            </Typography>
            <TextField
              sx={sxTextField}
              size="small"
              id="password"
              type="password"
              label="Old password"
              variant="outlined"
              value={password}
              onChange={(e) => set_password(e.target.value)}
            />
            <TextField
              sx={sxTextField}
              size="small"
              id="new_password"
              type="password"
              label="New password"
              variant="outlined"
              error={too_short}
              helperText={
                too_short ? `Tối thiểu ${MIN_PASSWORD} ký tự` : " "
              }
              value={new_password}
              onChange={(e) => set_new_password(e.target.value)}
            />
            <TextField
              sx={sxTextField}
              size="small"
              id="new_password_confirmation"
              type="password"
              label="Retype new password"
              variant="outlined"
              error={mismatch}
              helperText={mismatch ? "Password nhập lại không khớp" : " "}
              value={new_password_confirmation}
              onChange={(e) => set_new_password_confirmation(e.target.value)}
            />
            {change_pw_error !== "" && (
              <Typography
                sx={{ fontSize: 13, color: "#D32F2F", m: 0.5, mt: 1 }}
              >
                {change_pw_error}
              </Typography>
            )}
            <Button
              disabled={!canConfirm}
              variant="contained"
              disableElevation
              sx={{
                m: 0.5,
                width: "100%",
                maxWidth: 400,
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
                mt: 1,
              }}
              onClick={() => {
                set_change_pw_error("");
                API_changepassword(
                  {
                    username: my_username,
                    password: password,
                    newpassword: new_password,
                  },
                  (data) => {
                    if (data?.success) {
                      sessionStorage.removeItem(TOKEN_NAME);
                      navigate("/login", { replace: true });
                    } else {
                      // Wrong old password used to fail silently.
                      set_change_pw_error(
                        data?.message || "Đổi password thất bại"
                      );
                    }
                  }
                );
              }}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Box>

    </Box>
  );
}
